<div class="container-fluid">
  <div class="row">
    <div class="col-12 px-0">
      <div class="card p-0 border-0 shadow-none">
        <div class="card-body p-3">
          <div class="mb-4">
            <h1 class="card-title mb-1">Master</h1>
            <span class="sub-text">Manage warehouses, factories, companies, roles and designations</span>
          </div>

          <ul class="nav nav-pills mb-4">
            @for (tab of tabs; track tab.value) {
              <li class="nav-item">
                <button
                  class="nav-link"
                  [ngClass]="{ active: selectedTab === tab.value }"
                  (click)="selectTab(tab.value)">
                  <i [class]="tab.icon"></i>
                  <span class="ms-2">{{ tab.label }}</span>
                </button>
              </li>
            }
          </ul>

          <ng-container [ngSwitch]="selectedTab">
            <ng-container *ngSwitchCase="MasterTab.WAREHOUSES">
              <app-warehouses [wareHouses]="wareHouses" />
            </ng-container>

            <ng-container *ngSwitchCase="MasterTab.FACTORIES">
              <app-factories />
            </ng-container>

            <ng-container *ngSwitchCase="MasterTab.COMPANIES">
              <app-companies />
            </ng-container>

            <ng-container *ngSwitchCase="MasterTab.ROLES_AND_DESIGNATIONS">
              <app-roles />
              <app-designations />
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>
